'use strict';

const BookerPresenter = require('../presenters/booker');

const BaseView = require('./base');

const BookView = require('./book');

const DatePickerView = require('./datepicker');

const InfoView = require('./info');

const PickersView = require('./pickers');

const QuantityPickerView = require('./quantitypicker');

const SectionPickerView = require('./sectionpicker');

const TimePickerView = require('./timepicker');

class BookerView extends BaseView {
  constructor() {
    super(...arguments);

    this.selectDate = this.selectDate.bind(this);
    this.selectTime = this.selectTime.bind(this);
    this.selectQuantity = this.selectQuantity.bind(this);
    this.selectSection = this.selectSection.bind(this);
    this.model.on('updatedCollections', this.renderInfo, this);
    this.model.on('updatedCollections', this.renderBookButton, this);
    this.model.on('updatedCollections', this.enableClearButton, this);
    this.model.on('updatedCollections', this.displayCaptcha, this);
    this.model.on('clearAll', this.disableClearButton, this);
  }

  initialize() {
    this.setModule('glive_booking_redesign');
    this.presenter = BookerPresenter;
  }

  className() {
    return 'glive_booking_redesign-component';
  }

  events() {
    return {
      'submit form': 'book',
      'click .open .btn': 'open',
      'click .icon-close': 'close',
    };
  }

  book(event) {
    this.showSpinner();
    event.stopPropagation();
    this.model.book();
    return false;
  }

  clearAll() {
    return this.model.clearAll();
  }

  selectDate(date) {
    return this.model.selectDate(date);
  }

  selectTime(time) {
    return this.model.selectTime(time);
  }

  selectQuantity(quantity) {
    return this.model.selectQuantity(quantity);
  }

  selectSection(section) {
    return this.model.selectSection(section);
  }

  renderBookButton() {
    const bookContainer = this.$el.find('[data-book-now-content]');
    if (bookContainer.length) {
      bookContainer.html(new BookView({ model: this.model }).render().el);
    }
    $('#reservation-loader').hide();

    if (this.model.shouldShowCaptcha()) {
      this.resizeCaptcha();
    }
  }

  showSpinner() {
    if (this.model.showSpinner()) {
      $('#book-now-button').addClass('loading');
      $('#book-now-button').removeClass('c-txt-white');
    }
  }

  canRenderOptions() {
    return false;
  }

  canRenderPhone() {
    return false;
  }

  setOpen() {
    if (this.options.overlapWith) {
      $(this.options.overlapWith).hide();
    }
    this.options.isOpen = true;
    return this.options.isOpen;
  }

  setOpenAndLocked() {
    this.setOpen();
    this.options.isLocked = true;
    return this.options.isLocked;
  }

  open() {
    this.setOpen();
    this.model.reset();
    this.render({ fadeIn: true });
  }

  close() {
    this.options.isOpen = false;
    return this.$el.fadeOut(() => {
      this.render();
      if (this.options.overlapWith) {
        $(this.options.overlapWith).fadeIn();
      }
      return this.model.resetOption();
    });
  }

  render() {
    this.$el.hide();
    super.render(...arguments);
    if (!this.model.get('error')) {
      if (this.options.isOpen) {
        this.$el.find('[data-info-content]').hide();
        if (this.model.get('isSellable')) {
          this.renderCaptcha();
          this.renderInfo();
          this.renderPickers();
          this.renderClearButton();
        }
        this.renderBookButton();
      }
    }
    const showMethod = (arguments[0] != null ? arguments[0].fadeIn : undefined) === true ? 'fadeIn' : 'show';
    this.$el[showMethod]();
    return this;
  }

  renderInfo() {
    const infoContainer = this.$el.find('[data-glive-info-content]');
    return infoContainer.html(new InfoView({ model: this.model }).render().el);
  }

  renderPickers() {
    this.initializePickersView();
    this.pickersView.render();
    this.pickersView.once('expanded', () => this.trigger('ready'));
  }

  initializePickersView() {
    this.pickersView = new PickersView({
      el: this.$el.find('[data-pickers-content]'),
    });

    this.datePicker = this.pickersView.add({
      view: DatePickerView,
      model: this.model,
      collection: 'dates',
      selection: 'selectedDate',
      selected: this.selectDate,
    });

    this.timePicker = this.pickersView.add({
      view: TimePickerView,
      model: this.model,
      collection: 'times',
      selection: 'selectedTime',
      selected: this.selectTime,
    });

    this.quantityPicker = this.pickersView.add({
      view: QuantityPickerView,
      model: this.model,
      collection: 'quantities',
      selection: 'selectedQuantity',
      selected: this.selectQuantity,
    });

    this.sectionPicker = this.pickersView.add({
      view: SectionPickerView,
      model: this.model,
      collection: 'sections',
      selection: 'selectedSection',
      selected: this.selectSection,
    });
    return this.sectionPicker;
  }

  getPickersContainer() {
    return this.$el.find('[data-pickers-content]');
  }

  getBookNowContainer() {
    return this.$el.find('#book-now');
  }

  renderClearButton() {
    const pickersContainer = this.getPickersContainer();
    pickersContainer.append(
      '<div class="clear-button c-txt-prim ch-txt-white ch-bg-prim" data-bhw="GliveBookingDealBookerClearAll" >Clear All Selections</div>'
    );
    $('.clear-button').click(() => {
      this.clearAll();
    });
  }

  enableClearButton() {
    $('.clear-button').addClass('clear-enabled');
    $('.clear-button').addClass('c-txt-prim');
  }

  disableClearButton() {
    $('.clear-button').removeClass('clear-enabled');
    $('.clear-button').removeClass('c-txt-prim');
  }

  renderCaptcha() {
    if (!this.model.get('requiresCaptcha')) {
      return;
    }
    const siteKey = this.model.get('captchaSiteKey');
    const bookNowContainer = this.getBookNowContainer();
    const renderCallback = () => {
      this.renderBookButton();
    };

    $(window).resize(this.resizeCaptcha);
    window.recaptchaOnLoad = () => {
      window.grecaptcha.render('glive-recaptcha', {
        callback: renderCallback,
        'expired-callback': renderCallback,
        sitekey: siteKey,
      });
      this.resizeCaptcha();
    };

    const recaptchaJsUrl = this.model.get('recaptchaJsUrl');
    bookNowContainer.append($('<script async defer>').attr('src', recaptchaJsUrl));
  }

  resizeCaptcha() {
    const $grecaptchaDiv = $('#glive-recaptcha');
    if (!$grecaptchaDiv.children()[0]) {
      return;
    }

    const recaptchaMinWidth = 314;
    const scaleRatio = Math.min(recaptchaMinWidth, $grecaptchaDiv.width()) / $grecaptchaDiv.children().width();
    $grecaptchaDiv.children().css({ transform: `scale(${scaleRatio})` });
    if (this.model.shouldShowCaptcha()) {
      const scaledPadding = Math.ceil(Math.max(0, scaleRatio - 1) * 7);
      const padding = `${7 + scaledPadding}px 0 ${10 + scaledPadding}px`;
      $grecaptchaDiv.css({ padding });
    }
  }

  displayCaptcha() {
    if (this.model.shouldShowCaptcha()) {
      $('#glive-recaptcha').addClass('show');
    } else {
      $('#glive-recaptcha').removeClass('show');
    }

    this.resizeCaptcha();
  }
}

module.exports = BookerView;
